import React from 'react'
import { Incident } from '../../Interfaces'
import { useNavigate } from 'react-router-dom'
import IncidentsTable from "../tables/IncidentsTable"

interface IncidentsViewProps {
  locationId?: number;
  incidents?: Incident[];
  showUnresolvedOnly?: boolean;
  setShowUnresolvedOnly?: (value: boolean) => void;
  coordinates?: { lat: number; lng: number };
  zoom?: number;
  onIncidentClick?: (incident: Incident) => void;
}

export default function IncidentsView({
  locationId,
  incidents,
  showUnresolvedOnly,
  setShowUnresolvedOnly,
  coordinates,
  zoom,
  onIncidentClick
}: IncidentsViewProps) {
  const navigate = useNavigate()

  const handleIncidentClick = (incident: Incident) => {
    if (onIncidentClick) {
      onIncidentClick(incident)
    } else {
      navigate(`/app/incidents/${incident.id}`, {
        state: {
          from: locationId ? `/app/locations/${locationId}#incidents` : '/app/incidents'
        }
      })
    }
  }

  return (
    <div className="w-full">
      <IncidentsTable
        locationId={locationId}
        showUnresolvedOnly={showUnresolvedOnly}
        setShowUnresolvedOnly={setShowUnresolvedOnly}
        onIncidentClick={handleIncidentClick}
      />
    </div>
  )
}
